import React from 'react';
import { StyleSheet, useStyles } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { Body, Heading } from '@rexlabs/text';
import { ActionButtons } from './action-buttons';
var defaultStyles = StyleSheet({
  container: {
    padding: function padding(_ref) {
      var token = _ref.token;
      return token('spacing.xl');
    },
    borderRadius: function borderRadius(_ref2) {
      var token = _ref2.token;
      return token('border.radius.l');
    },
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  containerSmall: {
    padding: function padding(_ref3) {
      var token = _ref3.token;
      return token('spacing.l');
    }
  },
  containerLarge: {
    padding: function padding(_ref4) {
      var token = _ref4.token;
      return token('spacing.xxxl');
    }
  },
  containerGrey: {
    background: function background(_ref5) {
      var token = _ref5.token;
      return token('color.container.static.contrast');
    }
  },
  illustration: {
    height: '10rem',
    width: 'auto',
    marginBottom: function marginBottom(_ref6) {
      var token = _ref6.token;
      return token('spacing.m');
    }
  },
  icon: {
    display: 'flex',
    flexShrink: 0
  },
  iconFramed: {
    border: ".2rem solid currentColor",
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    width: '3.2rem',
    height: '3.2rem',
    marginBottom: function marginBottom(_ref7) {
      var token = _ref7.token;
      return token('spacing.m');
    }
  },
  iconFramedLarge: {
    width: '4.8rem',
    height: '4.8rem'
  },
  actions: {
    marginTop: function marginTop(_ref8) {
      var token = _ref8.token;
      return token('spacing.s');
    }
  }
});
export function Message(_ref9) {
  var title = _ref9.title,
      actions = _ref9.actions,
      Illustration = _ref9.Illustration,
      Icon = _ref9.Icon,
      grey = _ref9.grey,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 'm' : _ref9$size,
      children = _ref9.children;
  var s = useStyles(defaultStyles);
  var iconSize = size === 'l' ? 'xl' : 'l';
  var headingLevel = size === 'l' ? 3 : 4;
  return /*#__PURE__*/React.createElement(Box, s('container', {
    containerGrey: grey,
    containerLarge: size === 'l',
    containerMedium: size === 'm',
    containerSmall: size === 's'
  }), size !== 's' && Illustration && /*#__PURE__*/React.createElement(Illustration, s('illustration')), !Illustration && Icon && /*#__PURE__*/React.createElement(Box, s('icon', {
    iconFramed: size !== 's',
    iconFramedLarge: size === 'l'
  }), /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  })), size !== 's' && title && /*#__PURE__*/React.createElement(Heading, {
    level: headingLevel
  }, title), children && /*#__PURE__*/React.createElement(Body, {
    grey: true
  }, children), actions && /*#__PURE__*/React.createElement(Box, s('actions'), /*#__PURE__*/React.createElement(ActionButtons, {
    actions: actions,
    alignItems: "center"
  })));
}